var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState, useRef } from "react";
// MUI
import { Autocomplete as MuiAutocomplete, createFilterOptions, Paper, Popper, } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
// Components
import TextField from "../TextField";
import { CheckBoxOption, CheckIconOption, RadioOption } from "./components";
import { AutocompleteChip } from "../AutocompleteTagging";
// types
import { COLORS } from "../../../../constants";
import { AutocompleteOptionType } from "./types";
import { InlinePop } from "../../../Common";
var CustomPaper = function (props) { return (_jsx(Paper, __assign({}, props, { elevation: 0, sx: {
        border: "1px solid ".concat(COLORS.P_OUTLINE),
        borderRadius: 2,
        borderTop: "none",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        ".MuiAutocomplete-listbox": {
            p: 2,
        },
    } }))); };
var Autocomplete = function (_a) {
    var showSelectAll = _a.showSelectAll, onChangeCallback = _a.onChangeCallback, options = _a.options, value = _a.value, _b = _a.displaySelected, displaySelected = _b === void 0 ? true : _b, maxHeight = _a.maxHeight, _c = _a.size, size = _c === void 0 ? "medium" : _c, multiple = _a.multiple, _d = _a.optionsLimit, optionsLimit = _d === void 0 ? 100 : _d, disableClearable = _a.disableClearable, onOpen = _a.onOpen, onClose = _a.onClose, error = _a.error, inline = _a.inline, textFieldProps = _a.textFieldProps, _e = _a.optionType, optionType = _e === void 0 ? AutocompleteOptionType.CheckBox : _e, rest = __rest(_a, ["showSelectAll", "onChangeCallback", "options", "value", "displaySelected", "maxHeight", "size", "multiple", "optionsLimit", "disableClearable", "onOpen", "onClose", "error", "inline", "textFieldProps", "optionType"]);
    var _f = __read(useState(false), 2), open = _f[0], setOpen = _f[1];
    var scrollableRef = useRef(null);
    var isOpen = open || rest.open;
    useEffect(function () {
        if (maxHeight && (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current)) {
            scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
        }
    }, [value]);
    var allSelected = Array.isArray(value)
        ? options.length === value.length
        : false;
    /**
     * custom onChange function to handle the the scenario when a selectAll is needed
     */
    var handleChange = function (_event, selectedOptions, reason, _details) {
        if (onChangeCallback) {
            if (multiple && showSelectAll) {
                var multiItems = selectedOptions;
                if (reason === "selectOption" || reason === "removeOption") {
                    if (multiItems.find(function (option) { return option.id === "selectAll"; })) {
                        if (allSelected) {
                            return onChangeCallback(_event, []);
                        }
                        else {
                            return onChangeCallback(_event, options);
                        }
                    }
                }
                else if (reason === "clear") {
                    return onChangeCallback(_event, selectedOptions);
                }
            }
            return onChangeCallback(_event, selectedOptions);
        }
    };
    var filter = createFilterOptions({ limit: optionsLimit });
    // tbd need to discuss with qian
    var hasValue = multiple
        ? value === null || value === void 0 ? void 0 : value.length
        : value === null || value === void 0 ? void 0 : value.id;
    // styles for textfield
    var textFieldStyles = useMemo(function () { return ({
        px: 2,
        border: "1px solid ".concat(!!error ? COLORS.ERROR_DARK : COLORS.P_OUTLINE),
        borderRadius: 2,
        borderBottom: isOpen ? "none" : undefined,
        borderBottomLeftRadius: isOpen ? 0 : undefined,
        borderBottomRightRadius: isOpen ? 0 : undefined,
        input: {
            "&.MuiInput-input.MuiInput-input": {
                py: 2,
                pl: 2,
            },
        },
        ".MuiInputAdornment-positionEnd": {
            position: "absolute",
            right: 0,
        },
        ".MuiInput-underline::before, .MuiInput-underline::after": {
            border: isOpen ? undefined : "none !important",
        },
        ".MuiAutocomplete-popupIndicator": {
            transform: "none !important",
        },
        ".MuiAutocomplete-clearIndicator": {
            visibility: "visible !important",
        },
    }); }, [isOpen, !!error]);
    return (_jsx(MuiAutocomplete, __assign({ sx: {
            ".MuiOutlinedInput-root": {
                padding: 0,
                pl: 2,
            },
        }, PopperComponent: function (props) {
            var _a, _b;
            return inline ? (_jsx(InlinePop, __assign({}, props, { style: {
                    width: ((_a = props === null || props === void 0 ? void 0 : props.style) === null || _a === void 0 ? void 0 : _a.width)
                        ? Number(props.style.width) + 16 + 2 // add the 16 padding and 2 for border to the popper
                        : "auto",
                } }))) : (_jsx(Popper, __assign({}, props, { style: {
                    width: ((_b = props === null || props === void 0 ? void 0 : props.style) === null || _b === void 0 ? void 0 : _b.width)
                        ? Number(props.style.width) + 16 + 2 // add the 16 padding and 2 for border to the popper
                        : "auto",
                } })));
        }, open: open, onOpen: function (e) {
            setOpen(true);
            if (onOpen) {
                onOpen(e);
            }
        }, onClose: function (e, reason) {
            setOpen(false);
            if (onClose) {
                onClose(e, reason);
            }
        }, PaperComponent: CustomPaper, options: options, multiple: multiple, disableCloseOnSelect: multiple ? true : false, value: value, onChange: handleChange, clearIcon: displaySelected ? _jsx(ClearIcon, { fontSize: "small" }) : null, popupIcon: hasValue && !disableClearable ? null : _jsx(SearchIcon, { fontSize: "small" }), getOptionLabel: function (option) { return option.name; }, isOptionEqualToValue: function (option, value) { return option.id === value.id; }, renderInput: function (params) {
            var InputProps = params.InputProps, restParams = __rest(params, ["InputProps"]);
            var startAdornment = InputProps.startAdornment, restInputProps = __rest(InputProps, ["startAdornment"]);
            return (_jsx(TextField, __assign({}, restParams, { id: "autocomplete", "data-testid": "autocomplete", autoFocus // must be set or test inputs wont preserve
                : true, inputSize: size, variant: "standard", sx: textFieldStyles, 
                // dont delete on backspace when we're not showing selected items
                onKeyDown: function (event) {
                    if (multiple &&
                        !displaySelected &&
                        (event.key === "Backspace" || event.key === "Delete")) {
                        event.stopPropagation();
                    }
                }, InputProps: __assign(__assign({}, restInputProps), { style: __assign({}, (maxHeight
                        ? {
                            paddingRight: 35,
                        }
                        : {})), startAdornment: multiple && displaySelected && (value === null || value === void 0 ? void 0 : value.length) ? (_jsx("div", __assign({ style: {
                            padding: "5px 10px 5px 0",
                        } }, { children: _jsx("div", __assign({ ref: scrollableRef, style: {
                                maxHeight: maxHeight,
                                overflowY: maxHeight ? "auto" : "visible",
                            } }, { children: startAdornment })) }))) : undefined }), error: !!error }, textFieldProps)));
        }, filterOptions: function (filterOptions, params) {
            var filtered = filter(filterOptions, params);
            if (showSelectAll) {
                return __spreadArray([{ name: "All", id: "selectAll" }], __read(filtered), false);
            }
            return filtered;
        }, renderTags: function (tagValue, getTagProps) {
            if (displaySelected) {
                return tagValue.map(function (option, index) {
                    var props = getTagProps({ index: index });
                    var key = props.key, rest = __rest(props, ["key"]);
                    return (_createElement(AutocompleteChip, __assign({}, rest, { key: key, option: __assign(__assign({}, option), { color: (option === null || option === void 0 ? void 0 : option.color) || "LIGHT_GREY" }), deleteIcon: _jsx(CloseIcon, { "data-testid": "".concat(option.id, "-close-icon"), style: { color: COLORS.P_DISABLED } }) })));
                });
            }
            return null;
        }, renderOption: function (renderProps, option, state) {
            switch (optionType) {
                case AutocompleteOptionType.CheckBox:
                default:
                    return (_jsx(CheckBoxOption, { renderProps: renderProps, option: option, size: size, state: state, allSelected: allSelected }, option.id));
                case AutocompleteOptionType.CheckIcon:
                    return (_jsx(CheckIconOption, { renderProps: renderProps, size: size, option: option, state: state, allSelected: allSelected }, option.id));
                case AutocompleteOptionType.RadioButton:
                    return (_jsx(RadioOption, { renderProps: renderProps, size: size, option: option, state: state, allSelected: allSelected }, option.id));
            }
        } }, rest)));
};
export default Autocomplete;
